import { MTPayeeMasterTable } from './MTPayeeMasterTable'

/**
 * MTPayeeMasterPage - Renders the Payee Master table component.
 * Route: define/payee_master
 */
export function MTPayeeMasterPage() {
  return <MTPayeeMasterTable />
}
